var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E6FAF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.73 14H21.27V18.36H26.73V14ZM28.23 14V18.36H33.87C33.36 15.61 31.33 14.01 28.23 14ZM14 19.86V28.19C14 31.83 16.17 34 19.81 34H28.19C31.83 34 34 31.83 34 28.19V19.86H14ZM26.44 28.18L24.36 29.38C23.92 29.63 23.49 29.76 23.09 29.76C22.79 29.76 22.52 29.69 22.27 29.55C21.69 29.22 21.37 28.54 21.37 27.66V25.26C21.37 24.38 21.69 23.7 22.27 23.37C22.85 23.03 23.59 23.09 24.36 23.54L26.44 24.74C27.21 25.18 27.63 25.8 27.63 26.47C27.63 27.14 27.2 27.73 26.44 28.18ZM19.769 14C16.669 14.01 14.639 15.61 14.129 18.36H19.769V14Z",
    fill: "#00D084"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.bfd03fd75bdabd12ba8e07d79b3a36a0.svg";
export { ForwardRef as ReactComponent };